module.exports = __webpack_public_path__ + "img/Ripple.2181778.svg";